import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { registerServiceWorker } from './pwa/registerServiceWorker';
import { seedInitialData } from './db/seedData';
import { initAutoSync } from './sync';
import { warmupConnection } from './services/llm/openrouter';
import { fillMissingCnTranslations } from './db/migrations/v4_addCnTranslation';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerServiceWorker();

// 数据初始化流程：种子数据 -> 填充缺失的翻译
seedInitialData()
  .then(async () => {
    // 填充缺失的中文翻译（每次启动都检查）
    await fillMissingCnTranslations();
  })
  .catch((error) => {
    console.error('Failed to initialize data', error);
  });

// 初始化自动同步
initAutoSync();

// 预热 LLM 连接（减少首次请求延迟）
warmupConnection();
